import React, { useEffect } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import {
  creatingHeadingBlock,
  resetUser,
} from "../../../../../redux/slices/block/createBlockSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { toast } from "react-hot-toast";
import HeaderForm from "../forms/HeaderForm";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

const Header = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const { setActiveMainPageNav } = useStateContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const linkListData = {
    userId,
    usertoken,
    linkId,
  };
  const [subLoader, setSubLoader] = React.useState(false);

  const handleHeadingTextSubmit = async (data) => {
    setSubLoader(true);
    await dispatch(creatingHeadingBlock(data)).then(() => {});
    fetchingLinksList(); // fetching link list after submiting , so list become refresh
    setSubLoader(false);
  };
  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };
  // handling heading api reponses messages
  const { headingError, headingSuccess, headingLoading } = useSelector(
    (state) => state?.blockHeading
  );
  const { status, message } = useSelector(
    (state) => state?.blockHeading?.headingBlock
  );
  useEffect(() => {
    if (status === "success" && headingSuccess) {
      toast.success(message);
      navigate("/dashboard");
    }
    if (status === "failed" && headingError) {
      toast.error(message);
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headingError, headingSuccess, headingLoading]);

  return (
    <>
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">
              {" "}
              {translate("text_editor")}{" "}
            </p>
          </div>
        </Link>
      </div>

      <HeaderForm
        formType={"add"}
        submitHandlerParent={handleHeadingTextSubmit}
        isLoading={subLoader}
      />
    </>
  );
};

export default Header;
